/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonIdBasicDataQueryResponse,
  GetApiV1PersonIdBasicDataPathParams,
  GetApiV1PersonIdBasicData401,
  GetApiV1PersonIdBasicData404,
  GetApiV1PersonIdBasicData500,
} from "../../types/personRegisterController/GetApiV1PersonIdBasicData.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonIdBasicData } from "../../clients/personRegisterController/getApiV1PersonIdBasicData.ts";

export const getApiV1PersonIdBasicDataQueryKey = (
  id: GetApiV1PersonIdBasicDataPathParams["id"],
) => [{ url: "/api/v1/person/:id/basic-data", params: { id: id } }] as const;

export type GetApiV1PersonIdBasicDataQueryKey = ReturnType<
  typeof getApiV1PersonIdBasicDataQueryKey
>;

export function getApiV1PersonIdBasicDataQueryOptions(
  id: GetApiV1PersonIdBasicDataPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonIdBasicDataQueryKey(id);
  return queryOptions<
    GetApiV1PersonIdBasicDataQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdBasicData401
      | GetApiV1PersonIdBasicData404
      | GetApiV1PersonIdBasicData500
    >,
    GetApiV1PersonIdBasicDataQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonIdBasicData(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados básicos de uma pessoa (nome, e-mail, nascimento, nacionalidade). **(Requer Authorization para autenticação)**
 * @summary Obter dados básicos (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/basic-data}
 */
export function useGetApiV1PersonIdBasicData<
  TData = GetApiV1PersonIdBasicDataQueryResponse,
  TQueryData = GetApiV1PersonIdBasicDataQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonIdBasicDataQueryKey,
>(
  id: GetApiV1PersonIdBasicDataPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonIdBasicDataQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonIdBasicData401
          | GetApiV1PersonIdBasicData404
          | GetApiV1PersonIdBasicData500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1PersonIdBasicDataQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1PersonIdBasicDataQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonIdBasicData401
      | GetApiV1PersonIdBasicData404
      | GetApiV1PersonIdBasicData500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
